import { render, staticRenderFns } from "./TesterManage.vue?vue&type=template&id=3db66fa1&scoped=true"
import script from "./TesterManage.vue?vue&type=script&lang=js"
export * from "./TesterManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db66fa1",
  null
  
)

export default component.exports